// // @flow

import update from 'immutability-helper';
import type {ReduxActionType} from "../../flow/ReduxActionType";

const INITIAL_STATE = {
    billing: {
        email: '',
        name: '',
        phone: '',
        address: {
            city: '',
            country: '', // two-letter
            line1: '',
            line2: '',
            postal_code: '',
            state: '',
        },
        invoice_settings: {
            custom_fields: {
                name: 'Tax number',
                value: ''
            },
        }
    },
    saving: false,
    loading: true,
};

const makeNestedObj = (path, value) => {
    const pieces = path.split('.');
    pieces.push(value);
    return pieces.reverse().reduce((carry, value) => ({[value]: carry}));
};

type State = { type?: string };

const Billing = (state: State = INITIAL_STATE, action: ReduxActionType) => {
    switch (action.type) {
        case 'BILLING_LOAD':
            return {...INITIAL_STATE};

        case 'BILLING_LOADED':
            return {
                ...state,
                billing: {...action.payload},
                loading: false,
            };

        case 'BILLING_CHANGE_INPUT':
            return update(state, {
                billing: makeNestedObj(action.payload.name, {$set: action.payload.value})
            });

        case 'BILLING_SAVE':
            return {...state, saving: true};

        case 'BILLING_REQUEST_FAILED':
            return {...state, saving: false};

        default:
            return state;
    }
};

export default Billing;
